import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import axios from 'axios';
import { Button } from '../components/ui/button';
import { Mail, Loader2, CheckCircle } from 'lucide-react';
import { toast } from 'sonner';

import { BACKEND_URL } from '../config/api';

export default function VerifyEmailPending() {
  const { user, logout } = useAuth();
  const [resending, setResending] = useState(false);
  const [resent, setResent] = useState(false);

  const handleResend = async () => {
    setResending(true);
    try {
      const { data } = await axios.post(`${BACKEND_URL}/api/auth/resend-verification`, {}, { withCredentials: true });
      setResent(true);
      toast.success(data.message);
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Failed to resend');
    } finally {
      setResending(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F8F7F4] flex items-center justify-center p-4" data-testid="verify-email-pending-page">
      <div className="bg-white rounded-xl shadow-sm border border-[#E5E4E0] p-8 max-w-md w-full text-center space-y-5">
        <div className="w-16 h-16 bg-[#4B6651]/10 rounded-full flex items-center justify-center mx-auto">
          <Mail className="w-8 h-8 text-[#4B6651]" />
        </div>
        <h1 className="text-2xl font-bold text-[#2A2C2A] tracking-tight">Check Your Email</h1>
        <p className="text-[#5C5F5C] text-sm leading-relaxed">
          We've sent a verification link to <strong className="text-[#2A2C2A]">{user?.email}</strong>.
          Please click the link in the email to verify your account and get started.
        </p>
        <div className="bg-[#F8F7F4] rounded-lg p-4 text-left text-sm text-[#5C5F5C] space-y-1">
          <p>Didn't receive the email?</p>
          <ul className="list-disc pl-4 space-y-0.5 text-xs">
            <li>Check your spam or junk folder</li>
            <li>Make sure you entered the correct email</li>
            <li>The link expires in 24 hours</li>
          </ul>
        </div>
        <div className="space-y-3">
          <Button
            onClick={handleResend}
            disabled={resending || resent}
            className={resent ? "w-full bg-[#4B6651]/80 text-white" : "w-full bg-[#4B6651] hover:bg-[#3E5543] text-white"}
            data-testid="resend-verification-btn"
          >
            {resending ? (
              <><Loader2 className="w-4 h-4 animate-spin mr-2" /> Sending...</>
            ) : resent ? (
              <><CheckCircle className="w-4 h-4 mr-2" /> Email Resent</>
            ) : (
              'Resend Verification Email'
            )}
          </Button>
          <Button
            variant="ghost"
            onClick={logout}
            className="w-full text-[#5C5F5C]"
            data-testid="logout-btn"
          >
            Sign out and use a different email
          </Button>
        </div>
      </div>
    </div>
  );
}
